import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["template", "fieldContain"]
  static values = { "fieldClass" : String }

  addField(e) {
    e.preventDefault();

    const newField = this.buildNewAssociation(e);
    this.fieldContainTarget.insertAdjacentHTML("beforeend", newField);

    // Dispatch a custom event for Stimulus to catch
    const event = new CustomEvent("nested-rondo:add", {
      bubbles: true,
      detail: { element: this.fieldContainTarget.lastElementChild }
    });
    this.element.dispatchEvent(event);
  }

  removeField(e) {
    e.preventDefault();
    const wrapperField = this.hasFieldClassValue ? e.target.closest("." + this.fieldClassValue) : e.target.parentNode;

    // ✅ Dispatch a custom event including the *actual* removed element
    const event = new CustomEvent("nested-rondo:remove", {
      bubbles: true,
      detail: { element: wrapperField },
    });
    wrapperField.dispatchEvent(event);

    if(e.target.matches('.dynamic')) {
      wrapperField.remove();
    } else {
      wrapperField.querySelector("input[name*='_destroy']").value = 1;
      wrapperField.style.display = "none";
    }

  }

  buildNewAssociation(event) {
    let element = event.target;
    while (element) {
      if (element.hasAttribute('data-association') || element.hasAttribute('data-associations'))
        break
      element = element.parentElement;
    }
    const assoc = element.dataset.association;
    const assocs = element.dataset.associations;
    const content  = this.templateTarget.innerHTML;

    let regexpBraced = new RegExp('\\[new_' + assoc + '\\](.*?\\s)', 'g');
    let newId  = new Date().getTime();
    let newContent = content.replace(regexpBraced, '[' + newId + ']$1');

    if (newContent == content) {
      // assoc can be singular or plural
      regexpBraced = new RegExp('\\[new_' + assocs + '\\](.*?\\s)', 'g');
      newContent = content.replace(regexpBraced, '[' + newId + ']$1');
    }
    return newContent;
  }
}
